import { SortDirection } from '@material-ui/core';
import { OrderReportFilters } from 'features/order-history/ts/OrderReportFilters';

export const orderByToOrdering = (orderBy: SortDirection): OrderReportFilters['ordering'] => {
  switch (orderBy) {
    case 'asc':
      return 'created_at';
    case 'desc':
    default:
      return '-created_at';
  }
};

export const orderingToSortDirection = (ordering: OrderReportFilters['ordering']): SortDirection => {
  switch (ordering) {
    case '-created_at':
      return 'desc';
    case 'created_at':
      return 'asc';
    default:
      return false;
  }
};
